// extracted by mini-css-extract-plugin
module.exports = {"PrivateContactsListSummary":"_3ItCvobv","prefix":"SsuitSjd","body":"Umj9qlFn","name":"_2kiomnyT","description":"_2C9QYYHz","suffix":"_1C_Aza8w","selectListCheckbox":"y9vjCbqh"};